import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import {
  transactionFields,
  transactionParticipantFields,
  transactionEGOInfoFields,
} from '../../constants/transaction';

const TransactionSenderInformation = ({ info, t }) => {
  const participantData = info[transactionFields.SENDER_INFORMATION];
  const exportGoInfo =
    info[transactionFields.EXPORT_TRANSACTION_GO_INFORMATION];
  const goInformation = exportGoInfo?.[0];
  const transactionType = info.transactionType;

  function isImportTransaction() {
    return transactionType === 'IMPORT';
  }

  return (
    <Row className="global-margin-bottom-10">
      {isImportTransaction() ? (
        <>
          <Col span={8}>
            <b>{t('sender.registry')}: </b>
            {participantData?.[transactionParticipantFields.NAME]}
          </Col>
          <Col span={8}>
            <b>{t('sender.accountId')}: </b>
            {goInformation?.[transactionEGOInfoFields.SENDING_ACCOUNT_ID]}
          </Col>
        </>
      ) : (
        <>
          <Col span={8}>
            <b>{t('sender.name')}: </b>
            {participantData?.[transactionParticipantFields.NAME]}
          </Col>
          <Col span={8}>
            <b>{t('sender.code')}: </b>
            {participantData?.[transactionParticipantFields.CODE]}
          </Col>
        </>
      )}
      {participantData?.[transactionParticipantFields.EECS_CODE] && (
        <Col span={8}>
          <b>{t('sender.eecsCode')}: </b>
          {participantData?.[transactionParticipantFields.EECS_CODE]}
        </Col>
      )}
    </Row>
  );
};

TransactionSenderInformation.propTypes = {
  info: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default TransactionSenderInformation;
